
import S1 from "@/pages/S1";
import G1 from "@/pages/G1";
// import Atest01 from "@/pages/Atest01";
import Atype2026 from "@/pages/Atype_2026";
import Ay26 from "@/pages/Ay26";

import E404 from "@/pages/E404";
import Honors from "@/pages/Honors";
import Flow from "@/pages/Flow";

import Surl from "@/pages/Surl";
import S1menu from "@/pages/S1menu";
import Gurl from "@/pages/Gurl";
import G1menu from "@/pages/G1menu";
import Aphone from "@/pages/Ae/Aphone";

import { createBrowserRouter } from 'react-router-dom';


const router = createBrowserRouter([
    
    {
        path: "SD",
        element: <S1></S1>,
        children: [
            {
                path: "index",
                element: <S1menu />,
            },
            //honors
            {
                path: "honors",
                element: <Honors />
            },
            //FLOW
            {
                path: "flow",
                element: <Flow />
            },
            {
                path: "*",
                element: <E404 />
            }

        ],
    },
    {
        path: "GD",
        element: <G1></G1>,
        children: [
            {
                path: "index",
                element: <G1menu />,
            },
            {
                path: "honors",
                element: <Honors />
            },
            {
                path: "*",
                element: <E404 />
            }

        ],
    },
    {
        path: "/G/:dbcode",
        element: <Gurl />
    },
    {
        path: "/S/:dbcode",
        element: <Surl />
    },
    {
        path: "/p/:ename",
        element: <Aphone />
    },
    //  新规则   d 单个|t 团/年.dbno(36)/序号(36)/code
    {    
        path: "/:dblx/:ydbno/:index/:bsm",
        element: <Atype2026 />
    },
    {
        path: "Y26",
        element: <Ay26 />
    },

    //////没匹配的路径 
    {
        path: "*",
        element: <E404 />
    }
])
export default router